document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.uq-accordion__trigger');
  if (trigger) {
    var item = trigger.closest('.uq-accordion__item');
    item.classList.toggle('is-open');
    trigger.querySelector('.uq-accordion__sign').textContent = item.classList.contains('is-open') ? '—' : '+';
    return;
  }

  var burger = event.target.closest('.uq-header__burger');
  if (burger) {
    var header = document.querySelector('.uq-header');
    var isOpen = header.classList.toggle('is-nav-open');
    burger.setAttribute('aria-expanded', isOpen);
    return;
  }

  var accountToggle = event.target.closest('[data-uq-account-toggle]');
  if (accountToggle) {
    var login = document.getElementById('uq-login');
    var recover = document.getElementById('uq-recover-password');
    if (login) login.classList.toggle('is-hidden');
    if (recover) recover.classList.toggle('is-hidden');
  }

  var thumb = event.target.closest('[data-uq-gallery-thumb]');
  if (thumb) {
    var gallery = thumb.closest('[data-uq-gallery]');
    if (!gallery) return;
    var mainImage = gallery.querySelector('[data-uq-gallery-main]');
    if (mainImage && thumb.dataset.fullSrc) {
      mainImage.src = thumb.dataset.fullSrc;
    }
    var siblings = gallery.querySelectorAll('[data-uq-gallery-thumb]');
    siblings.forEach(function (el) { el.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }
});

document.addEventListener('change', function (event) {
  var sort = event.target.closest('[data-uq-sort]');
  if (sort) {
    window.location.href = sort.value;
    return;
  }

  var noteField = event.target.closest('[data-uq-autosubmit] input, [data-uq-autosubmit] textarea');
  if (noteField) {
    noteField.form.requestSubmit();
  }
});

(function () {
  function initUqInfiniteScroll() {
    var link = document.querySelector('.uq-plp-pagination [data-infinite-scrolling]');
    var grid = document.querySelector('.uq-plp-grid');
    if (!link || !grid || link.classList.contains('disabled') || typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    }, { rootMargin: '600px' });

    observer.observe(link);

    function loadNextPage() {
      var current = document.querySelector('.uq-plp-pagination [data-infinite-scrolling]');
      if (!current || current.dataset.uqLoading === 'true') return;
      var url = current.dataset.href || current.getAttribute('href');
      if (!url || url === 'javascript:void(0)') return;

      current.dataset.uqLoading = 'true';
      var originalText = current.textContent;
      current.textContent = current.dataset.loadingMore || originalText;
      observer.unobserve(current);

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.uq-plp-grid');
          var currentGrid = document.querySelector('.uq-plp-grid');
          if (newGrid && currentGrid) {
            var cards = Array.prototype.slice.call(newGrid.children);
            cards.forEach(function (card) { currentGrid.appendChild(card); });
          }

          var newLink = doc.querySelector('.uq-plp-pagination [data-infinite-scrolling]');
          var pagination = document.querySelector('.uq-plp-pagination');
          if (newLink && !newLink.classList.contains('disabled')) {
            current.setAttribute('href', newLink.getAttribute('href'));
            current.dataset.href = newLink.dataset.href;
            current.textContent = originalText;
            current.dataset.uqLoading = 'false';
            observer.observe(current);
          } else if (pagination) {
            pagination.style.display = 'none';
          }
        })
        .catch(function () {
          current.textContent = originalText;
          current.dataset.uqLoading = 'false';
          observer.observe(current);
        });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUqInfiniteScroll);
  } else {
    initUqInfiniteScroll();
  }
})();

(function () {
  function initUqVariantPickers() {
    document.querySelectorAll('.uq-variant-picker').forEach(function (picker) {
      var dataScript = picker.querySelector('script[type="application/json"]');
      if (!dataScript) return;

      var variants;
      try {
        variants = JSON.parse(dataScript.textContent);
      } catch (e) {
        return;
      }

      var productId = picker.dataset.product;
      var form = document.getElementById('product-form-' + productId);
      if (!form) return;

      var idInput = form.querySelector('input[name="id"]');
      var addButton = form.querySelector('[name="add"]');
      var skuEl = document.querySelector('[data-uq-sku-for="' + productId + '"]');
      var fieldsets = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));

      function getSelectedOptions() {
        return fieldsets.map(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function findMatchingVariant() {
        var selected = getSelectedOptions();
        return variants.find(function (variant) {
          return variant.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function updateAvailability() {
        var selected = getSelectedOptions();
        fieldsets.forEach(function (fieldset, idx) {
          var radios = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
          radios.forEach(function (radio) {
            var hypothetical = selected.slice();
            hypothetical[idx] = radio.value;
            var isAvailable = variants.some(function (variant) {
              if (!variant.available) return false;
              return variant.options.every(function (opt, i) { return opt === hypothetical[i]; });
            });
            var label = radio.nextSibling;
            if (!label || !label.classList) return;
            label.classList.toggle('soldout', !isAvailable);
          });
        });
      }

      function updateSku(variant) {
        if (!skuEl) return;
        var label = skuEl.dataset.skuLabel || 'SKU';
        if (variant && variant.sku) {
          skuEl.textContent = label + ': ' + variant.sku;
        } else {
          skuEl.textContent = '';
        }
      }

      function updateForSelection() {
        var variant = findMatchingVariant();
        if (variant) {
          idInput.value = variant.id;
          if (addButton) {
            addButton.disabled = !variant.available;
            addButton.textContent = variant.available
              ? (addButton.dataset.addLabel || addButton.textContent)
              : (addButton.dataset.soldOutLabel || addButton.textContent);
            addButton.dataset.available = variant.available;
          }
        } else if (addButton) {
          addButton.disabled = true;
          if (addButton.dataset.soldOutLabel) addButton.textContent = addButton.dataset.soldOutLabel;
        }
        updateSku(variant);
        updateAvailability();
      }

      picker.addEventListener('change', updateForSelection);
      updateForSelection();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUqVariantPickers);
  } else {
    initUqVariantPickers();
  }
})();

(function () {
  var WISHLIST_KEY = 'uq_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    } catch (e) {
      /* localStorage unavailable — wishlist state just won't persist */
    }
  }

  function paintWishlistButton(button, isSaved) {
    button.classList.toggle('is-active', isSaved);
    button.setAttribute('aria-pressed', isSaved);
  }

  function initUqWishlistButtons() {
    var saved = getWishlist();
    document.querySelectorAll('[data-uq-wishlist-toggle]').forEach(function (button) {
      var card = button.closest('[data-uq-card]');
      if (!card) return;
      paintWishlistButton(button, saved.indexOf(card.dataset.product) !== -1);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-uq-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();

    var card = button.closest('[data-uq-card]');
    if (!card) return;

    var productId = card.dataset.product;
    var saved = getWishlist();
    var index = saved.indexOf(productId);

    if (index === -1) {
      saved.push(productId);
      paintWishlistButton(button, true);
    } else {
      saved.splice(index, 1);
      paintWishlistButton(button, false);
    }

    setWishlist(saved);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUqWishlistButtons);
  } else {
    initUqWishlistButtons();
  }
})();

(function () {
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  document.addEventListener('click', function (event) {
    var sizeButton = event.target.closest('[data-uq-card-size]');
    if (sizeButton) {
      if (sizeButton.disabled) return;
      var card = sizeButton.closest('[data-uq-card]');
      if (!card) return;

      var siblings = card.querySelectorAll('[data-uq-card-size]');
      siblings.forEach(function (el) { el.classList.remove('is-selected'); });
      sizeButton.classList.add('is-selected');

      var addButton = card.querySelector('[data-uq-card-add]');
      if (addButton) {
        addButton.dataset.variantId = sizeButton.dataset.variantId;
        addButton.disabled = false;
        addButton.textContent = addButton.dataset.addLabel;
      }
      return;
    }

    var addButton = event.target.closest('[data-uq-card-add]');
    if (addButton) {
      event.preventDefault();
      if (addButton.dataset.busy === 'true') return;

      var variantId = addButton.dataset.variantId;
      if (!variantId) {
        var originalLabel = addButton.dataset.addLabel;
        addButton.textContent = addButton.dataset.selectLabel;
        window.setTimeout(function () {
          addButton.textContent = originalLabel;
        }, 1800);
        return;
      }

      var addUrl = document.body.dataset.cartAddUrl || '/cart/add.js';
      addButton.dataset.busy = 'true';
      var addLabel = addButton.dataset.addLabel;
      var addedLabel = addButton.dataset.addedLabel;

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) { return response.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (response) { return response.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          addButton.textContent = addedLabel;
          window.setTimeout(function () {
            addButton.textContent = addLabel;
            addButton.dataset.busy = 'false';
          }, 1800);
        })
        .catch(function () {
          addButton.textContent = addLabel;
          addButton.dataset.busy = 'false';
        });
    }
  });
})();
